import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./SyphilisKazakhstan.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getKazakhstanDiseaseDetails } from "../../redux/InformationSlice";
import { useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const SyphilisKazahkstan = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector(
    (state: RootState) => state.info.kazakhstanDiseaseDetails,
  );
  const params = useParams();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getKazakhstanDiseaseDetails(Number(params.id)));
  }, [dispatch, params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Миграция в Казахстан и сифилис"
        description="Лечение сифилиса для иностранцев и мигрантов в Казахстане. Как получить вид на жительство (ВНЖ) после излечения сифилиса."
        url="https://www.vputi.org/kazakhstan/syphilis/2"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}

        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов с диагнозом сифилис",
            path: "/kazakhstan",
          }}
        />
        <ContactButtons />
        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>

            <div className={s.body_2_wrapper}>
              <div
                className={s.body2}
                dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
              ></div>
            </div>
            <div className={s.text_title2}>{disease?.title_3}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
            ></div>
            <div
              className={s.yellow_wrapper}
              dangerouslySetInnerHTML={{ __html: disease?.body_4 ?? "" }}
            ></div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_5 ?? "" }}
            ></div>
            <div className={s.text_title2}>{disease?.title_6}</div>
            <div
              className={s.body6_wrapper}
              dangerouslySetInnerHTML={{ __html: disease?.body_6 ?? "" }}
            ></div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_7 ?? "" }}
            ></div>
            <div
              className={s.yellow_wrapper}
              dangerouslySetInnerHTML={{ __html: disease?.body_8 ?? "" }}
            ></div>
          </div>

          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>

          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default SyphilisKazahkstan;
